var map = {
	"./3-CN.png": "b3ry",
	"./3-EN.png": "GGAA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RTSy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m ^\.\/3\-.*\.png$
// module id = RTSy
// module chunks = 1